import { TSideNav } from './sidenav.types';

export const ROUTES: TSideNav[] = [
  {
    path: '/admin/dashboard',
    title: 'sideNav.dashboard',
    icon: 'dashboard',
    class: '',
    roles: ['superadmin']
  },
  {
    path: '/admin/roles',
    title: 'sideNav.roles',
    icon: 'spanner',
    class: '',
    roles: ['superadmin']
  },
  {
    path: '/admin/tenants',
    title: 'sideNav.tenants',
    icon: 'users',
    class: '',
    roles: ['superadmin']
  },
  {
    path: '/admin/customers',
    title: 'sideNav.customers',
    icon: 'accounts',
    class: '',
    roles: ['superadmin']
  },
  {
    path: '/admin/profiles',
    title: 'sideNav.profiles',
    icon: 'folders',
    class: '',
    roles: ['superadmin']
  },
  {
    path: '/admin/media-archives',
    title: 'sideNav.media_archives',
    icon: 'media',
    class: '',
    roles: ['superadmin']
  },
  // {
  //   path: "/admin/tests/tol",
  //   title: "Tower of London",
  //   icon: "dashboard",
  //   class: "",
  //   roles: ["superadmin"]
  // },
  // {
  //   path: "/tests",
  //   title: "sideNav.tests",
  //   icon: "dashboard",
  //   class: "",
  //   roles: ["testtaker"]
  // },
  {
    title: 'sideNav.customer_management',
    icon: 'home',
    class: '',
    isCompanyManagement: true,
    roles: ['superadmin', 'administrator'],
    children: [
      {
        path: '/admin/customer/dashboard',
        title: 'sideNav.dashboard',
        icon: 'dashboard',
        class: '',
        roles: ['superadmin', 'administrator']
      },
      {
        path: '/admin/customer/projects',
        title: 'sideNav.projects',
        icon: 'projects',
        class: '',
        roles: ['superadmin', 'administrator']
      },
      {
        path: '/admin/customer/test-takers',
        title: 'sideNav.test_takers',
        icon: 'test-takers',
        class: '',
        roles: ['superadmin', 'administrator']
      },
      {
        path: '/admin/customer/profiles',
        title: 'sideNav.profiles',
        icon: 'folders',
        class: '',
        roles: ['superadmin', 'administrator']
      },
      {
        path: '/admin/customer/users',
        title: 'sideNav.users',
        icon: 'users',
        class: '',
        roles: ['superadmin', 'administrator']
      }
    ]
  }
];
